import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`;
export const SET_SHARED_STATE = `${SCOPE}/SET_SHARED_STATE`;
export const SET_METRIC_FILTER = `${SCOPE}/SET_METRIC_FILTER`;
export const SET_VIEW_CONTEXT = `${SCOPE}/SET_VIEW_CONTEXT`;

export const INIT_METRIC_FILTER = `${SCOPE}/INIT_METRIC_FILTER`;
export const ADD_METRIC_FILTER = `${SCOPE}/ADD_METRIC_FILTER`;
export const REMOVE_METRIC_FILTER = `${SCOPE}/REMOVE_METRIC_FILTER`;
export const CLEAR_METRIC_FILTER = `${SCOPE}/CLEAR_METRIC_FILTER`;

export const SET_DIMENSIONS = `${SCOPE}/SET_DIMENSIONS`;
export const SET_DIMENIONS_TO_NA = `${SCOPE}/SET_DIMENIONS_TO_NA`;
export const UPDATE_DIMENSION = `${SCOPE}/UPDATE_DIMENSION`;
export const SET_SELECTED_DIMENSION = `${SCOPE}/SET_SELECTED_DIMENSION`;
export const SWAP_SELECTED_DIMENSION = `${SCOPE}/SWAP_SELECTED_DIMENSION`;
export const ADD_DIMENSION = `${SCOPE}/ADD_DIMENSION`;
export const REMOVE_DIMENSION = `${SCOPE}/REMOVE_DIMENSION`;

export const DIMENSION_DRILLDOWN = `${SCOPE}/DIMENSION_DRILLDOWN`;

export const MULTI_DIMENSION_DRILLDOWN = `${SCOPE}/MULTI_DIMENSION_DRILLDOWN`;
export const APPLY_ERROR_FILTER = `${SCOPE}/APPLY_ERROR_FILTER`;

export const INIT_RULE = `${SCOPE}/INIT_RULE`;
export const TOGGLE_RULE = `${SCOPE}/TOGGLE_RULE`;
export const SET_RULES = `${SCOPE}/SET_RULES`;
export const REMOVE_RULE = `${SCOPE}/REMOVE_RULE`;
export const UPDATE_RULE = `${SCOPE}/UPDATE_RULE`;
export const APPLY_FILTER = `${SCOPE}/APPLY_FILTER`;
export const RESET_FILTER = `${SCOPE}/RESET_FILTER`;

export const INIT_COMPARE = `${SCOPE}/INIT_COMPARE`;
export const INIT_COMPARE_FILTER = `${SCOPE}/INIT_COMPARE_FILTER`;
export const ADD_COMPARE_FILTER = `${SCOPE}/ADD_COMPARE_FILTER`;
export const ADD_TOP_COMPARE_FILTERS = `${SCOPE}/ADD_TOP_COMPARE_FILTERS`;
export const REMOVE_COMPARE_FILTER = `${SCOPE}/REMOVE_COMPARE_FILTER`;
export const SET_COMPARE_FILTERS = `${SCOPE}/SET_COMPARE_FILTERS`;
export const SET_ACTIVE_FILTER = `${SCOPE}/SET_ACTIVE_FILTER`;
export const TOGGLE_COMPARE_RULE = `${SCOPE}/TOGGLE_COMPARE_RULE`;
export const REMOVE_COMPARE_RULE = `${SCOPE}/REMOVE_COMPARE_RULE`;
export const UPDATE_COMPARE_RULE = `${SCOPE}/UPDATE_COMPARE_RULE`;
export const ADD_SAVED_FILTER = `${SCOPE}/ADD_SAVED_FILTER`;
export const UPDATE_ACTIVE_FILTER = `${SCOPE}/UPDATE_ACTIVE_FILTER`;
export const COMPARE_FILTERS = `${SCOPE}/COMPARE_FILTERS`;
export const COMPARE_FILTERS_ON_TRENDS = `${SCOPE}/COMPARE_FILTERS_ON_TRENDS`;
export const RESET_COMPARE = `${SCOPE}/RESET_COMPARE`;
export const MODIFY_COMPARE_INIT = `${SCOPE}/MODIFY_COMPARE_INIT`;

export const APPLY_COMPARE_FILTERS_ON_TRENDS = `${SCOPE}/APPLY_COMPARE_FILTERS_ON_TRENDS`;
export const CLEAR_COMPARE_FILTERS_ON_TRENDS = `${SCOPE}/CLEAR_COMPARE_FILTERS_ON_TRENDS`;
export const REMOVE_COMPARE_FILTERS_ON_TRENDS = `${SCOPE}/REMOVE_COMPARE_FILTERS_ON_TRENDS`;
export const EDIT_COMPARE_FILTERS_ON_TRENDS = `${SCOPE}/EDIT_COMPARE_FILTERS_ON_TRENDS`;
export const ADD_COMPARE_FILTER_ON_TRENDS = `${SCOPE}/ADD_COMPARE_FILTER_ON_TRENDS`;
export const QUICK_COMPARE_FILTER = `${SCOPE}/QUICK_COMPARE_FILTER`;
export const QUICK_COMPARE_TOP_FILTERS = `${SCOPE}/QUICK_COMPARE_TOP_FILTERS`;

export const SET_GLOBAL_ORDER_BY = `${SCOPE}/SET_GLOBAL_ORDER_BY`;
export const SET_DIMENSION_METRICS = `${SCOPE}/SET_DIMENSION_METRICS`;
export const SET_DIMENIONS_METRICS_TO_NA = `${SCOPE}/SET_DIMENIONS_METRICS_TO_NA`;

export const HIGHLIGHT_COMPARE_FILTER = `${SCOPE}/HIGHLIGHT_COMPARE_FILTER`;

export const PERSIST_ATOMS = `${SCOPE}/PERSIST_ATOMS`;
export const PERSIST_WIDGETS = `${SCOPE}/PERSIST_WIDGETS`;
